<app-navbar></app-navbar>
<div class="container my-4">
    <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{length:6}"></ng-otp-input>
    <button (click)="veryFy($event)" class="btn  mt-3 mb-4" [ngClass]="btnStaus">{{inputDigit}}</button>
</div>